import { keycloak } from "../../..";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function AccountDeactivated() {
  const handleLogout = async () => {
    try {
      localStorage.clear();
      await keycloak.logout();
    } catch (error) {
      localStorage.clear();
      window.location.assign("/");
    }
  };

  return (
    <SidebarLayout isHide isLogoTitle hideHeaderActions>
      <div className="flex min-h-[calc(100vh-9.5rem)] items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-[30px] font-semibold leading-tight text-[#343A40]">
            Your account has been deactivated. Please contact your admin.
          </h1>
          <button
            type="button"
            onClick={handleLogout}
            className="mt-6 text-base font-medium text-[#ff6b00] underline underline-offset-4"
          >
            Logout
          </button>
        </div>
      </div>
    </SidebarLayout>
  );
}
